import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M3.885 4.667l1.69 1.69-.942.943-3.3-3.3 3.3-3.3.943.943-1.69 1.69h4.78a5.333 5.333 0 010 10.667h-6v-1.333h6a4 4 0 100-8h-4.78z"
      ></path>
    </svg>
  )
}

export default Icon
